const getters = {
  getVoiceCampaignsRunning: (state) => () => {
    return state.campaignVoiceList.filter(
      (campaign) =>
        campaign.dialer_execution_status != 'STOPPING' &&
        campaign.dialer_execution_status != 'STOPPED',
    );
  },
  getVoiceCampaignName: (state) => (dialerExecutionId) => {
    const strategyCampaignFound = state.campaignVoiceList.find(
      (strategyCampaign) =>
        strategyCampaign.id == dialerExecutionId.dialer_execution,
    );
    if (strategyCampaignFound == undefined) {
      return '';
    }
    return strategyCampaignFound.name;
  },
};

export default getters;
